import React, { ForwardedRef } from 'react'
import { ToggleButtonGroup, ToggleButtonGroupProps } from '../../ui/ToggleButtonGroup/ToggleButtonGroup'
import { typedMemo } from '../../utils/react-utils'

export type ToggleButtonGroupFieldProps<
  T extends string,
  Mode extends 'single' | 'multi' = 'multi',
> = ToggleButtonGroupProps<T, Mode>

export const ToggleButtonGroupField = typedMemo(
  React.forwardRef(
    <T extends string, Mode extends 'single' | 'multi' = 'multi'>(
      props: ToggleButtonGroupFieldProps<T, Mode>,
      ref: ForwardedRef<HTMLDivElement>,
    ) => (
      <div ref={ref}>
        {/* For whatever reason, TypeScript says the `props` isn't the right type because it doesn't have
            "IntrinsicAttributes" or something */}
        <ToggleButtonGroup {...(props as unknown as React.ComponentProps<typeof ToggleButtonGroup>)} />
      </div>
    ),
  ),
)
